import React, { useState } from "react";
import Collapsible from "react-collapsible";
import "../css/Dashboard.css";
import Crud_Noticias from "../components/crud/Crud_Noticias";
import Crud_Redes from "../components/crud/Crud_Redes.js";
import Crud_Reportes from "../components/crud/Crud_Reportes";
import Crud_Eventos from "../components/crud/Crud_Eventos";
import Crud_Prensa from "../components/crud/Crud_Prensa";
import Crud_Banner from "../components/crud/Crud_Banner";
import Crud_Miembros from "../components/crud/Crud_Miembros";
import Crud_Reporte from "../components/crud/Crud_Reporte";
import Crud_Reporte_2 from "../components/crud/Crud_Reporte_2";
import Crud_Reporte_3 from "../components/crud/Crud_Reporte_3";
import Crud_Que_Hacemos from "../components/crud/Crud_Que_Hacemos";
import Crud_Que_Hacemos_2 from "../components/crud/Crud_Que_Hacemos_2";
import Crud_Que_Hacemos_3 from "../components/crud/Crud_Que_Hacemos_3";
import Crud_Fecha_Reporte from "../components/crud/Crud_Fecha_Reporte";
import Crud_Proyectos from "../components/crud/Crud_Proyectos";
import Crud_Servicios from "../components/crud/Crud_Servicios";
import Crud_Laboratorio from "../components/crud/Crud_Laboratorio";
import Crud_Laboratorio_2 from "../components/crud/Crud_Laboratorio_2";
import Crud_Laboratorio_3 from "../components/crud/Crud_Laboratorio_3";
import Crud_Investigacion from "../components/crud/Crud_Investigacion";
import Crud_Visualizador from "../components/crud/Crud_Visualizador.js";
import Crud_Footer from "../components/crud/Crud_Footer";
import Crud_Footer_2 from "../components/crud/Crud_Footer_2";
import Crud_Footer_3 from "../components/crud/Crud_Footer_3";
import Inicio_Dashboard from "../components/Inicio_Dashboard";

function Dashboard() {
  const [activeForm, setActiveForm] = useState("Inicio_Dashboard");

  const renderForm = () => {
    switch (activeForm) {
      case "Crud_Noticias":
        return <Crud_Noticias />;
      case "Crud_Redes":
        return <Crud_Redes />;
      case "Crud_Reportes":
        return <Crud_Reportes />;
      case "Crud_Eventos":
        return <Crud_Eventos />;
      case "Crud_Prensa":
        return <Crud_Prensa />;
      case "Crud_Banner":
        return <Crud_Banner />;
      case "Crud_Miembros":
        return <Crud_Miembros />;
      case "Crud_Reporte":
        return <Crud_Reporte />;
      case "Crud_Reporte_2":
        return <Crud_Reporte_2 />;
      case "Crud_Reporte_3":
        return <Crud_Reporte_3 />;
      case "Crud_Que_Hacemos":
        return <Crud_Que_Hacemos />;
      case "Crud_Que_Hacemos_2":
        return <Crud_Que_Hacemos_2 />;
      case "Crud_Que_Hacemos_3":
        return <Crud_Que_Hacemos_3 />;
      case "Crud_Fecha_Reporte":
        return <Crud_Fecha_Reporte />;
      case "Crud_Proyectos":
        return <Crud_Proyectos />;
      case "Crud_Servicios":
        return <Crud_Servicios />;
      case "Crud_Laboratorio":
        return <Crud_Laboratorio />;
      case "Crud_Laboratorio_2":
        return <Crud_Laboratorio_2 />;
      case "Crud_Laboratorio_3":
        return <Crud_Laboratorio_3 />;
      case "Crud_Investigacion":
        return <Crud_Investigacion />;
      case "Crud_Visualizador":
        return <Crud_Visualizador />;
      case "Crud_Footer":
        return <Crud_Footer />;
      case "Crud_Footer_2":
        return <Crud_Footer_2 />;
      case "Crud_Footer_3":
        return <Crud_Footer_3 />;
      case "Inicio_Dashboard":
        return <Inicio_Dashboard />;
    }
  };

  return (
    <div className="Dashboard">
      <nav className="Sidebar">
        <h1 onClick={() => setActiveForm("Inicio_Dashboard")}>Admin</h1>
        <h3>Componentes</h3>
        <Collapsible trigger="Inicio">
          <button onClick={() => setActiveForm("Crud_Noticias")}>
            Noticias
          </button>
          <button onClick={() => setActiveForm("Crud_Eventos")}>
            Próximos Eventos
          </button>
          <button onClick={() => setActiveForm("Crud_Redes")}>
            Plataformas
          </button>
          {/*<button onClick={() => setActiveForm("Crud_Reportes")}>
            Reporte de Embalses
          </button>*/}
          <button onClick={() => setActiveForm("Crud_Prensa")}>
            Prommra en Prensa
          </button>
          <button onClick={() => setActiveForm("Crud_Banner")}>
            Banner Principal
          </button>
        </Collapsible>
        <Collapsible trigger="Reporte de embalse">
          <button onClick={() => setActiveForm("Crud_Fecha_Reporte")}>
            Fecha Reporte
          </button>
          <button onClick={() => setActiveForm("Crud_Reporte")}>
            Provincia del Elqui
          </button>
          <button onClick={() => setActiveForm("Crud_Reporte_2")}>
            Provincia del Limarí
          </button>
          <button onClick={() => setActiveForm("Crud_Reporte_3")}>
            Provincia del Choapa
          </button>
        </Collapsible>
        <Collapsible trigger="¿Quiénes somos?">
          <button onClick={() => setActiveForm("Crud_Miembros")}>
            Equipo Prommra
          </button>
          <button onClick={() => setActiveForm("Crud_Que_Hacemos")}>
            ¿Qué hacemos?
          </button>
          <button onClick={() => setActiveForm("Crud_Que_Hacemos_2")}>
            Lineas de trabajo
          </button>
          <button onClick={() => setActiveForm("Crud_Que_Hacemos_3")}>
            Servicios
          </button>
        </Collapsible>
        <Collapsible trigger="Proyectos" className="Colapasable">
          <button onClick={() => setActiveForm("Crud_Proyectos")}>
            Proyectos
          </button>
        </Collapsible>
        <Collapsible trigger="Servicios" className="Colapasable">
          <button onClick={() => setActiveForm("Crud_Servicios")}>
            Servicios
          </button>
        </Collapsible>
        <Collapsible trigger="Líneas de Investigación" className="Colapasable">
          <button onClick={() => setActiveForm("Crud_Laboratorio")}>
            Laboratorio Presentación
          </button>
          <button onClick={() => setActiveForm("Crud_Laboratorio_2")}>
            Laboratorio Imágenes
          </button>
          <button onClick={() => setActiveForm("Crud_Laboratorio_3")}>
            Laboratorio Capacidades
          </button>
          <button onClick={() => setActiveForm("Crud_Investigacion")}>
            Líneas de Investigación
          </button>
        </Collapsible>
        <Collapsible trigger="Visualizadores de Suelo" className="Colapasable">
          <button onClick={() => setActiveForm("Crud_Visualizador")}>
            Zonas de Visualización
          </button>
        </Collapsible>
        <Collapsible trigger="Footer" className="Colapasable">
          <button onClick={() => setActiveForm("Crud_Footer")}>
            Datos de contacto
          </button>
          <button onClick={() => setActiveForm("Crud_Footer_2")}>
            Logos Universidad
          </button>
          <button onClick={() => setActiveForm("Crud_Footer_3")}>
            Redes Sociales
          </button>
        </Collapsible>
      </nav>
      <div className="mainDashboard">
        <nav className="Topbar">Dashboard</nav>
        {renderForm()}
      </div>
    </div>
  );
}

export default Dashboard;
